<template>
  <NavBar />
  <main>
    <router-view />
  </main>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  components: {
    NavBar,
  },
};
</script>

<style>
/* Global Styles */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.page {
  width: 100%;
  margin-top: 20px;
}

.article {
  text-align: left;
  margin: auto 45px;
}

a {
  font-weight: bold;
  font-size: 18px;
}

a.router-link-exact-active {
  color: #000000;
}

h2, h3 {
  margin-top: 18px;
}
</style>
